/* src/app/private/modules/manage-campaign/components/email-report/email-report.component.scss */
.email-report-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.report-header .header-content {
  flex: 1;
}
.report-header .header-content .report-title {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.report-header .header-content .report-title i {
  font-size: 1.2rem;
}
.report-header .header-content .campaign-name {
  margin: 0.5rem 0 0 0;
  font-size: 0.95rem;
  opacity: 0.95;
  font-weight: 500;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
}
.loading-container .loading-text {
  color: #64748b;
  font-size: 1rem;
}
.report-content {
  flex: 1;
}
.statistics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.stat-card {
  background: white;
  border-radius: 8px;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}
.stat-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}
.stat-card .stat-icon {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}
.stat-card .stat-details {
  flex: 1;
}
.stat-card .stat-details .stat-label {
  margin: 0;
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}
.stat-card .stat-details .stat-value {
  margin: 0.25rem 0 0 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}
.stat-card .stat-details .stat-percentage {
  margin: 0.25rem 0 0 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
}
.stat-card.stat-total {
  border-left-color: #3b82f6;
}
.stat-card.stat-total .stat-icon {
  background: #dbeafe;
  color: #3b82f6;
}
.stat-card.stat-sent {
  border-left-color: #3b82f6;
}
.stat-card.stat-sent .stat-icon {
  background: #dbeafe;
  color: #3b82f6;
}
.stat-card.stat-delivered {
  border-left-color: #10b981;
}
.stat-card.stat-delivered .stat-icon {
  background: #d1fae5;
  color: #10b981;
}
.stat-card.stat-opened {
  border-left-color: #8b5cf6;
}
.stat-card.stat-opened .stat-icon {
  background: #ede9fe;
  color: #8b5cf6;
}
.stat-card.stat-clicked {
  border-left-color: #f59e0b;
}
.stat-card.stat-clicked .stat-icon {
  background: #fef3c7;
  color: #f59e0b;
}
.stat-card.stat-bounced {
  border-left-color: #ef4444;
}
.stat-card.stat-bounced .stat-icon {
  background: #fee2e2;
  color: #ef4444;
}
.stat-card.stat-complained {
  border-left-color: #dc2626;
}
.stat-card.stat-complained .stat-icon {
  background: #fecaca;
  color: #dc2626;
}
.stat-card.stat-rejected {
  border-left-color: #6b7280;
}
.stat-card.stat-rejected .stat-icon {
  background: #f3f4f6;
  color: #6b7280;
}
.view-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
.view-toggle ::ng-deep .p-selectbutton .p-button {
  padding: 0.625rem 1.25rem;
  background: white;
  border: 2px solid #e2e8f0;
  color: #64748b;
  font-weight: 600;
  font-size: 0.875rem;
}
.view-toggle ::ng-deep .p-selectbutton .p-button.p-highlight {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}
.view-toggle ::ng-deep .p-selectbutton .p-button:not(.p-highlight):hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.status-tabs {
  display: flex;
  gap: 0.625rem;
  margin-bottom: 1.25rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}
.status-tabs::-webkit-scrollbar {
  height: 4px;
}
.status-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.status-tab {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-weight: 600;
  color: #64748b;
  font-size: 0.875rem;
}
.status-tab:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  transform: translateY(-1px);
}
.status-tab.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}
.status-tab.active .tab-count {
  background: rgba(255, 255, 255, 0.25);
  color: white;
}
.status-tab i {
  font-size: 0.875rem;
}
.status-tab .tab-label {
  font-size: 0.875rem;
}
.status-tab .tab-count {
  background: #f1f5f9;
  padding: 0.125rem 0.5rem;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
}
.data-table-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.data-table-container ::ng-deep .p-datatable .p-datatable-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.data-table-container ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 0.875rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.875rem;
}
.data-table-container ::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
  background: #f8fafc;
}
.data-table-container ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding: 0.875rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.875rem;
}
.data-table-container .email-cell,
.data-table-container .timestamp-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.data-table-container .email-cell i,
.data-table-container .timestamp-cell i {
  color: #94a3b8;
}
.data-table-container .event-type-badge {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  background: #f1f5f9;
  border-radius: 6px;
  font-size: 0.813rem;
  font-weight: 600;
  color: #475569;
}
.data-table-container .event-count-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  background: #dbeafe;
  border-radius: 6px;
  font-size: 0.813rem;
  font-weight: 700;
  color: #1e40af;
}
.data-table-container .event-count-badge i {
  font-size: 0.75rem;
}
.data-table-container .status-badge {
  display: inline-block;
  padding: 0.375rem 0.875rem;
  border-radius: 20px;
  font-size: 0.813rem;
  font-weight: 700;
  text-transform: capitalize;
}
.data-table-container .status-badge.status-sent {
  background: #dbeafe;
  color: #1e40af;
}
.data-table-container .status-badge.status-delivered {
  background: #d1fae5;
  color: #065f46;
}
.data-table-container .status-badge.status-opened {
  background: #ede9fe;
  color: #6b21a8;
}
.data-table-container .status-badge.status-clicked {
  background: #fef3c7;
  color: #92400e;
}
.data-table-container .status-badge.status-bounced {
  background: #fee2e2;
  color: #991b1b;
}
.data-table-container .status-badge.status-complained {
  background: #fecaca;
  color: #7f1d1d;
}
.data-table-container .status-badge.status-rejected {
  background: #f3f4f6;
  color: #374151;
}
.data-table-container .message-id-cell {
  font-family: "Courier New", monospace;
  font-size: 0.75rem;
  color: #64748b;
  cursor: help;
}
.data-table-container .empty-state {
  padding: 3rem 2rem;
  text-align: center;
  color: #94a3b8;
}
.data-table-container .empty-state i {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}
.data-table-container .empty-state p {
  font-size: 1rem;
  font-weight: 500;
}
.charts-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
}
.chart-card {
  background: white;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.chart-card .chart-header {
  margin-bottom: 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 0.875rem;
}
.chart-card .chart-header .chart-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.chart-card .chart-header .chart-title i {
  color: var(--primary-color);
  font-size: 1.125rem;
}
.chart-card .chart-header .chart-subtitle {
  margin: 0.375rem 0 0 0;
  font-size: 0.813rem;
  color: #64748b;
}
.chart-card .chart-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.metrics-card {
  grid-column: 1/-1;
}
.metrics-card .metrics-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.25rem;
}
.metrics-card .metric-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
}
.metrics-card .metric-item:hover {
  background: #f1f5f9;
  transform: translateX(3px);
}
.metrics-card .metric-item .metric-icon {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}
.metrics-card .metric-item .metric-icon.engagement {
  background: #ede9fe;
  color: #8b5cf6;
}
.metrics-card .metric-item .metric-icon.click {
  background: #fef3c7;
  color: #f59e0b;
}
.metrics-card .metric-item .metric-icon.bounce {
  background: #fee2e2;
  color: #ef4444;
}
.metrics-card .metric-item .metric-icon.delivery {
  background: #d1fae5;
  color: #10b981;
}
.metrics-card .metric-item .metric-info {
  flex: 1;
}
.metrics-card .metric-item .metric-info .metric-label {
  margin: 0;
  font-size: 0.813rem;
  color: #64748b;
  font-weight: 600;
}
.metrics-card .metric-item .metric-info .metric-value {
  margin: 0.25rem 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}
.metrics-card .metric-item .metric-info .metric-description {
  margin: 0;
  font-size: 0.7rem;
  color: #94a3b8;
}
.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #94a3b8;
  text-align: center;
}
.no-data-container i {
  font-size: 5rem;
  margin-bottom: 1.5rem;
  opacity: 0.5;
}
.no-data-container h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
  color: #64748b;
}
.no-data-container p {
  margin: 0;
  font-size: 1rem;
}
@media (max-width: 768px) {
  .report-header {
    padding: 1rem;
  }
  .report-header .header-content .report-title {
    font-size: 1rem;
  }
  .report-content {
    padding: 1rem;
  }
  .statistics-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 0.75rem;
  }
  .stat-card {
    padding: 0.875rem;
    flex-direction: column;
    text-align: center;
  }
  .stat-card .stat-icon {
    width: 35px;
    height: 35px;
    font-size: 1.125rem;
  }
  .stat-card .stat-details .stat-value {
    font-size: 1.25rem;
  }
  .charts-container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .status-tabs {
    gap: 0.5rem;
  }
  .status-tab {
    padding: 0.5rem 0.875rem;
    font-size: 0.813rem;
  }
}
/*# sourceMappingURL=email-report.component.css.map */
